export const REGULAR = "REGULAR";
export const READ_ONLY = "READ_ONLY";
export const BANK_STATEMENTS = "BANK_STATEMENTS";
